import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { Pill } from '@feathr/components';

import * as styles from './SelectedTargetings.css';

interface IProps {
  name: string;
  included: boolean;
}

function LocationChip({ name, included }: Readonly<IProps>): JSX.Element {
  return (
    <Pill
      className={styles.pill}
      prefix={
        <FontAwesomeIcon className={'icon'} icon={included ? faCircleCheck : faCircleXmark} />
      }
      theme={included ? 'blue' : 'neutral'}
    >
      {name}
    </Pill>
  );
}

export default observer(LocationChip);
